<div class="list-page list-page--wide">
  <header class="page-header">
    <h1 class="page-header__title">Active</h1>
    <p class="page-header__subtitle">
      Your authorized projects in progress — open each site's workspace and track
      your deliverables to completion.
    </p>
  </header>

  <div *ngIf="data?.length > 0; else placeholder">
    <ng-container *ngFor="let item of data; trackBy: trackByProjectId">
      <app-project-group
        [project]="item"
        [type]="'active'"
        [testIdProjectScope]="item.projectId"
        (atpSigned)="signedAtpSiteVisits = $event"
      ></app-project-group>
    </ng-container>
  </div>
  <ng-template #placeholder>
    <div *ngIf="loading; else notLoading" class="empty-state" data-testid="active-loading">
      <p class="empty-state__title">Loading active projects…</p>
    </div>
    <ng-template #notLoading>
      <div class="empty-state" data-testid="active-empty">
        <p class="empty-state__title">No active projects</p>
        <p class="empty-state__text">Projects you're actively working on will appear here.</p>
      </div>
    </ng-template>
  </ng-template>
</div>

<site-visit-confirmation-dialog
  [active]="siteVisitConfirmationActive"
  (modalClose)="toggleCloseSiteVisitConfirmationModal()"
/>
<decline-success
  [batch]="declineBatch"
  [active]="declineSuccessActive"
  [address]="address"
  [isFixedPrice]="isFixedPrice"
  [isAtp]="isAtp"
  (modalClosed)="toggleCloseDeclineSuccessModal()"
  [ngClass]="{ 'documents-dialog--active': declineSuccessActive }"
/>
<accepted-offered-proposal-dialog
  [active]="isOfferAcceptedActive"
  [multiple]="isOfferAcceptedMultiple"
  (modalClosed)="toggleCloseOfferAcceptedModal()"
  [ngClass]="{ 'documents-dialog--active': isOfferAcceptedActive }"
/>
<atp-sign-accepted-dialog
  [active]="isAtpSignAccepted"
  [address]="address"
  [modalHeaderTitle]="atpModalHeaderTitle"
  [modalBody]="atpModalBody"
  [dashboard]="false"
  [siteVisits]="signedAtpSiteVisits"
  (modalClosed)="toggleCloseAtpSignAcceptedModal()"
  [ngClass]="{ 'documents-dialog--active': isAtpSignAccepted }"
/>
